export default () => ({
  createListButton: {
    textTransform: 'none',
  },
  createListIcon: {
    marginRight: 5,
  },
});
